<div class="modal-header" [attr.data-theme]="'dark'">
  <h2>Wybierz kolor tła</h2>
</div>

<div class="modal-body">
  <!-- wbudowany picker HTML5 -->
  <input type="color" [(ngModel)]="color" style="width:100%; height:48px; border:none; padding:0;" />
</div>

<div class="modal-footer" style="display:flex; justify-content:flex-end; gap:8px; margin-top:16px;">
  <as-button
        [useSubmitBehavior]="true"
        [size]="btnSize.Large"
        [variant]="btnVariant.Tertiary"
        (click)="cancel()"
        [label]="'creator.cancelButton' | translate"
        [customClass]="'w-100'"
      ></as-button>

      <as-button
        [useSubmitBehavior]="true"
        [size]="btnSize.Special"
        [variant]="btnVariant.DarkStyle"
        (click)="save()"
        [label]="'creator.saveButton' | translate"
        [customClass]="'w-100'"
      ></as-button>
</div>
